var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    fill: "none",
    viewBox: "0 0 16 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.372 3.227A6.967 6.967 0 0 0 16 1.535a6.16 6.16 0 0 1-1.879.501A3.213 3.213 0 0 0 15.561.22a6.94 6.94 0 0 1-2.066.815A3.287 3.287 0 0 0 11.085 0a3.288 3.288 0 0 0-3.289 3.29c0 .25.032.5.094.751A9.537 9.537 0 0 1 1.096.595a3.2 3.2 0 0 0-.438 1.66c0 1.128.563 2.13 1.471 2.726-.532-.032-1.064-.157-1.503-.408v.032a3.293 3.293 0 0 0 2.63 3.226c-.25.063-.563.126-.845.126-.22 0-.407-.032-.626-.063a3.272 3.272 0 0 0 3.068 2.287 6.608 6.608 0 0 1-4.07 1.41c-.282 0-.533-.032-.783-.063C1.44 12.468 3.162 13 5.041 13c6.043 0 9.33-4.98 9.33-9.335v-.438Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgTwitter);
export default Memo;